import { useKeyHandler, focusTrap } from "@/scripts";

const MenuToggleModule = (menuToggle: HTMLButtonElement) => {
  const mediaLargeScreen = window.matchMedia("screen and (min-width: 2300px)");
  const navbar = document.querySelector(".navbar") as HTMLElement;
  const navbarFlyout = document.getElementById(
    "navbar-flyout"
  ) as HTMLDivElement;
  const headerMenuToggle = document.getElementById(
    "header-menu-toggle"
  ) as HTMLButtonElement;
  const navbarMenuToggle = document.getElementById(
    "navbar-menu-toggle"
  ) as HTMLButtonElement;
  const menuTabloopCloseBtn = document.querySelector(
    ".menu-toggle-tabloop"
  ) as HTMLButtonElement;

  // Handler for focus trap
  const handleFocusTrap = focusTrap(navbarFlyout);

  // Toggle open/closed state
  const toggle = (e: Event) => {
    const menuToggle = e.target as HTMLButtonElement;

    if (menuToggle.getAttribute("aria-expanded") === "false") {
      open();
    } else {
      close();
    }
  };

  // Close menu when click is outside of navbar and menuToggle
  const handleClickoutside = (e: Event) => {
    !navbarFlyout.contains(e.target as Node) &&
    e.target !== menuToggle &&
    close();
  }

  const open = () => {
    if (navbarFlyout) {
      if(!mediaLargeScreen.matches)
        document.body.style.overflow = "hidden"; // Prevent body scroll

      document.body.classList.add("fade-overlay");

      menuToggle.setAttribute("aria-expanded", "true");

      if(!mediaLargeScreen.matches)
      {
        menuToggle.focus();
      }
      
      navbarFlyout.classList.add("flyout--visible");
      navbarFlyout.classList.remove("flyout--hidden-xxl");
      navbar.classList.add("navbar--reveal", "navbar--visible");

      scrollToActiveMenuItem();

      if(!mediaLargeScreen.matches)
      {
        handleFocusTrap.activate();
        // Close when user clicks outside of menu element
        window.addEventListener("click", handleClickoutside);
  
        // Close menu when user hits Escape key
        useKeyHandler("Escape", close);
      }
    }
  };

  const close = () => {
    if (navbarFlyout) {
      if(!mediaLargeScreen.matches)
        document.body.style.overflow = "auto"; // Allow body scroll

      document.body.classList.remove("fade-overlay");

      menuToggle.setAttribute("aria-expanded", "false");
      
      navbarFlyout.classList.remove("flyout--visible");
      navbarFlyout.classList.add("flyout--hidden-xxl");

      navbar.classList.remove("navbar--visible");

      if (document.documentElement.scrollTop === 0) {
        navbar.classList.remove("navbar--reveal");
      }
    }

    window.removeEventListener("click", handleClickoutside);

    handleFocusTrap.deactivate();
  };

  const scrollToActiveMenuItem = () => {
    const activeMenuItem = document.querySelector(".menu__item--active");
    const mq = window.matchMedia("(max-width: 1024px)");
    const navbarOffset = mq.matches ? navbar.offsetHeight : 0;

    if (activeMenuItem) {
      setTimeout(() => {
        const offsetTop = activeMenuItem.getBoundingClientRect().top;
        navbarFlyout.scrollTo(0, offsetTop - navbarOffset);
      }, 10);
    }
  };

  const init = () => {
    menuToggle.addEventListener("click", toggle);
    headerMenuToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      navbarMenuToggle.click();
    });

    if (menuTabloopCloseBtn) {
      menuTabloopCloseBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        navbarMenuToggle.click();
      });

      if (mediaLargeScreen.matches) {
        menuToggle.setAttribute("aria-expanded", "true");
        scrollToActiveMenuItem()
      } 
    }
  };

  return {
    init,
    open,
  };
};

const initiateMenuToggles = () => {
  document.querySelectorAll(".menu-toggle").forEach((menuToggle) => {
    if (menuToggle.getAttribute("aria-controls") !== "navbar-menu-toggle") {
      MenuToggleModule(menuToggle as HTMLButtonElement).init();
    }
  });
};

export { MenuToggleModule, initiateMenuToggles };
